import { Badge } from '@sunstone/ui';
import { SearchableCombobox } from '@/components/ui/SearchableCombobox';
import type { RolePickerItem, useRolePicker } from './useRolePicker';

interface RolePickerComboboxProps {
  value: string;
  onChange: (value: string) => void;
  rolePicker: Pick<
    ReturnType<typeof useRolePicker>,
    'items' | 'search' | 'setSearch' | 'isLoading' | 'footer'
  >;
}

/**
 * The role picker's combobox + badges (grantsAll, System/Custom scope) —
 * shared by the invite wizard and the member-detail edit modal so both
 * show the same scope distinction (item 1).
 */
export function RolePickerCombobox({ value, onChange, rolePicker }: RolePickerComboboxProps) {
  return (
    <SearchableCombobox<RolePickerItem>
      value={value}
      onChange={onChange}
      items={rolePicker.items}
      search={rolePicker.search}
      onSearchChange={rolePicker.setSearch}
      isLoading={rolePicker.isLoading}
      footer={rolePicker.footer}
      placeholder="Select a role…"
      searchPlaceholder="Search roles…"
      renderItem={(role) => (
        <span className="flex items-center gap-2">
          {role.displayName}
          <Badge variant="outline" className="text-[10px]">
            {role.grantsAll ? 'Always current' : 'Fixed list'}
          </Badge>
          <Badge variant="secondary" className="text-[10px]">
            {role.scope}
          </Badge>
        </span>
      )}
    />
  );
}
